<script setup lang="ts">
import type { FavoriteButtonProps } from '.';

import { cn } from '@/utils';

import IconMaterialSymbolsLightStar from '~icons/material-symbols-light/star';
import IconMaterialSymbolsLightStarOutline from '~icons/material-symbols-light/star-outline';

import { favoriteButtonVariants } from '.';
import { Button } from '../ui/button';

const props = withDefaults(defineProps<FavoriteButtonProps>(), {
	ariaLabel: 'Adicionar à minha coleção'
});

const isFavorite = defineModel<boolean>('isFavorite', { default: false });

const emit = defineEmits<{
	(e: 'toggle'): void;
	(e: 'error', error: string): void;
}>();

function handleToggleFavorite() {
	if (props.disableInteraction) return;
	emit('toggle');
}
</script>

<template>
	<Button
		variant="transparent"
		:is-client-only="false"
		:class="
			cn(
				favoriteButtonVariants({
					state: isFavorite ? 'active' : 'inactive'
				}),
				props.class as string
			)
		"
		:aria-pressed="isFavorite"
		:aria-label="props.ariaLabel"
		@click.stop.prevent="handleToggleFavorite"
		@pointerdown.stop.prevent
		@mousedown.stop.prevent
		@mouseup.stop.prevent
		@touchstart.stop.prevent
		@touchend.stop.prevent="handleToggleFavorite"
		@keydown.enter.stop.prevent="handleToggleFavorite"
		@keydown.space.stop.prevent="handleToggleFavorite"
	>
		<component
			:is="
				isFavorite
					? IconMaterialSymbolsLightStar
					: IconMaterialSymbolsLightStarOutline
			"
			:class="
				cn(
					'flex size-6 shrink-0 scale-110 items-center justify-center text-primary',
					props.iconClass as string
				)
			"
		/>
	</Button>
</template>
